import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';

export type CustomerCountryVehicle = Pick<VehicleCycledEnergyRecord, 'customerCountry' | 'chassisNumber'>;

const useCustomerCountries = (data: CustomerCountryVehicle[] | undefined): string[] => {
  return useMemo<string[]>(() => {
    if (!data) return [];

    const unique = new Set<string>();

    for (const vehicle of data) {
      if (vehicle.customerCountry) {
        unique.add(vehicle.customerCountry);
      }
    }

    return [...unique].toSorted((a, b) => a.localeCompare(b));
  }, [data]);
};

export default useCustomerCountries;
